export default function animationsComponent() {
    return {
        observer: null,
        animated: new Set(),
        
        init() {
            const elements = document.querySelectorAll("[data-animate]");
            if (!elements.length) return;
            
            // Create intersection observer
            this.observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    // Check if element is intersecting and hasn't been animated yet
                    if (entry.isIntersecting && !this.animated.has(entry.target)) {
                        this.triggerAnimation(entry.target);
                    }
                });
            }, {
                threshold: 0,
                rootMargin: "0px 0px -100px 0px"
            });
            
            // Start observing all elements
            elements.forEach(el => {
                this.observer.observe(el);
            });
        },
        
        triggerAnimation(element) {
            // Mark as animated immediately to prevent double-triggering
            this.animated.add(element);
            
            const delay = parseFloat(element.dataset.delay) || 0;
            const animateChildren = element.hasAttribute("data-animate-elements");
            
            if (animateChildren) {
                // Stagger children animations
                const children = Array.from(element.children);
                children.forEach((child, index) => {
                    const totalDelay = (delay + (index * 0.15)) * 1000;
                    setTimeout(() => {
                        child.classList.add("animate-in");
                    }, totalDelay);
                });
            } else {
                // Animate the element itself
                setTimeout(() => {
                    element.classList.add("animate-in");
                }, delay * 1000);
            }
            
            // Stop observing this element after animation starts
            this.observer.unobserve(element);
        },
        
        destroy() {
            if (this.observer) {
                this.observer.disconnect();
                this.observer = null;
            }
            this.animated.clear();
        }
    };
}